import {useEffect, useRef, useState} from 'react'
import {documentsApi, DocumentParentView} from '@dv5/api'
import {ErrorDisplayProcessor} from '@dv5/components'
import {useAppDispatch} from '@dv5/domain'

export const useDocumentParents = (documentId: string, showOutline: boolean) => {
    const dispatch = useAppDispatch()
    const [parents, setParents] = useState<Array<DocumentParentView>>([])
    const [parentsLoaded, setParentsLoaded] = useState(false)
    const requestedForRef = useRef<string | null>(null)

    useEffect(() => {
        if (!showOutline || requestedForRef.current === documentId) {
            return
        }
        requestedForRef.current = documentId
        setParentsLoaded(false)
        setParents([])
        const errorProcessor = new ErrorDisplayProcessor(dispatch)
        documentsApi.getDocumentParents(documentId, errorProcessor)
            .then(response => {
                if (requestedForRef.current === documentId) {
                    setParents(response.parents || [])
                    setParentsLoaded(true)
                }
            })
            .catch(reason => {
                console.error(reason)
                if (requestedForRef.current === documentId) {
                    setParentsLoaded(true)
                }
            })
    }, [documentId, showOutline, dispatch])

    return {parents, parentsLoaded}
}
